import React from "react";
import { useSelector } from "react-redux";
import ApproveGlobal from "../../../../components/datagrid/EmployeeService/PostWorkingHours/ApproveGlobal";
import {
  approveOrRejectSaleRequest,
  getSale,
} from "../../../../redux/features/assetManagementSlice";
import RejectGlobal from "../../../../components/datagrid/EmployeeService/PostWorkingHours/RejectGlobal";

const RejectRequirement = ({ saleId, dispatchParams, disable }) => {
  const { loading } = useSelector((store) => store.assetmanagement);
  return (
    <RejectGlobal
      statusChangeApiCall={approveOrRejectSaleRequest({ saleId, status: 2 })}
      loading={loading}
      upDateCall={getSale(dispatchParams)}
      isDisabled={disable}
      buttonName={"Reject"}
    />
  );
};

export default RejectRequirement;
